import { Injectable } from '@angular/core';
import { AuthService } from '../shared/auth/auth.service';
import { Http, Response, URLSearchParams, Headers } from '@angular/http';
import { BaseService } from '../shared/service/base.service';
import { Observable } from 'rxjs';
import { Module } from 'app/shared/model/module.model';

@Injectable()
export class CompanyService extends BaseService<any> {

  constructor(_authService: AuthService,
    _http: Http) {
    super('/api/promotionurls/', _authService, _http);
  }

  getModules(url: string): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();

    if (this._authService.getUserData() != null) {
      console.log(this._authService.getUserData().breezeSessionString);
      if (this._authService.getUserData().breezeSessionString !== undefined) {
        params.set('breezeSessionString', this._authService.getUserData().breezeSessionString);
      } else {
        params.set('breezeSessionString', this._authService.getBreezeSessionString());
      }
      console.log(this._authService.getUserData().iBreezeUserID);
      if (this._authService.getUserData().iBreezeUserID !== undefined) {
        params.set('iBreezeUserID', this._authService.getUserData().iBreezeUserID);
      } else {
        params.set('iBreezeUserID', '');
      }
    }
    return this._http.get(this._baseUrl + '/getCoursesByUrlName/' + url, {
      headers: this._authService.getAuthorizationHeaders(),
      search: params
    })
      .map((res: Response) => res.json())
      ;

  }

}



// WEBPACK FOOTER //
// ./src/app/company/company.service.ts